<ion-row class="captcha-wrapper">
	<ng-container *ngIf="showCaptcha">
		<re-captcha
			#captchaRef
			siteKey="6LflZ8QkAAAAAMwchzEi28VnUfkmPvTFiplzh9Lo"
			(resolved)="captchaResolved($event)"
			(expired)="captchaExpired()"
			(error)="captchaError()"
		>
		</re-captcha>
	</ng-container>
</ion-row>
